import { useEffect, useContext, useRef } from 'react';
import { useState } from 'react';

const useRemainingSeconds = ({ context }) => {
  const { isLoggedIn, remainingTime } = useContext(context);

  const [secondsLeft, setSecondsLeft] = useState(Math.floor(remainingTime / 1000));

  const intervalRef = useRef();

  useEffect(() => {
    if (isLoggedIn) {
      intervalRef.current = setInterval(() => {
        setSecondsLeft((prevSeconds) => {
          return prevSeconds - 1;
        });
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isLoggedIn]);

  useEffect(() => {
    setSecondsLeft(Math.floor(remainingTime / 1000));
  }, [remainingTime]);

  return { secondsLeft };
};

export default useRemainingSeconds;
